export const optionStates = [
    { name: "Aktiv", description: "Zuweisung an Thema möglich", code: "active" },
    {
        name: "Inaktiv",
        description: "Keine Zuweisung an neue Themen möglich",
        code: "inactive",
    },
];

export const units = [
    { name: "keine", value: null },
    { name: "m2", value: "m2" },
    { name: "l", value: "l" },
    { name: "stk", value: "stk" },
    { name: "m", value: "m" },
    { name: "m3", value: "m3" },
    { name: "h", value: "h" },
];
